// Half a rem per character: a little wider than an average character at the 14px table font. Unlike `ch`, it does not
// depend on each cell's own font, so header and row cells get exactly the same width.
const labelWidth = (labels: string[]): number => 0.5 * Math.max(0, ...labels.map((label) => label.length))

// Width of a table column that holds one secondary action button, sized to its longest label so translated labels
// (e.g. "Bewerken", "Modifier") keep the same space to the right border as "Edit": the cell's side padding (2 × 1.25rem),
// the button's side padding (2 × 1rem), a little headroom, and the label.
export const actionColumnWidth = (...labels: string[]): string => `${4.75 + labelWidth(labels)}rem`

// Same, for a button with an icon before its label: the icon and its spacing add 1.25rem.
export const iconActionColumnWidth = (...labels: string[]): string => `${6 + labelWidth(labels)}rem`
